import React, { Component } from "react";
import "./Login.css";
import { Auth } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";


export default class Login extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      errorMsg: ""
    };
  }

  validateForm(){
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event =>{

      this.setState({
          errorMsg: "",
         [event.target.id] : event.target.value
      });

  }


  handleSubmit = async event => {
    event.preventDefault();

    if(this.state.email.length === 0){
      this.setState({errorMsg: "Email cannot be empty."});
      return;
    }
    if(this.state.password.length === 0){
      this.setState({errorMsg: "Password cannot be empty."});
      return;
    }

    this.setState( { isLoading: true, errorMsg: "" } );
    try{
      var retVal = await Auth.signIn(this.state.email, this.state.password);
      console.log("User Details: " + JSON.stringify(retVal));
      this.props.userHasAuthenticated(true);
      this.props.history.push("/blogs");
    } catch(e){
      this.setState( {isLoading: false, errorMsg: e.message} );
    }
  }



  render(){
      var errorElement = this.state.errorMsg && this.state.errorMsg.length > 0
                              ? <div class="alert alert-danger" role="alert">
                                  {this.state.errorMsg}
                                </div>
                              : "";

      return (
        <section className="slice-lg has-bg-cover bg-size-cover loginpagebg" >
          <div className="container">
              <div className="row justify-content-center cols-xs-space">
                  <div className="col-lg-4">
                      <div className="form-card form-card--style-2 z-depth-2-top">
                          <div className="form-header text-center">
                              <div className="form-header-icon">
                                      <img src="/images/logo_retnetindia.png" />

                              </div>
                          </div>
                          <div className="form-body">
                              <div className="text-center px-2">
                                  <h4 className="heading heading-4 strong-400 mb-4">Sign in to your account</h4>
                              </div>
                              {errorElement}
                              <form className="form-default" role="form" onSubmit={this.handleSubmit} >
                                  <div className="row">
                                      <div className="col-12">
                                          <div className="form-group">
                                              <label>Email</label>
                                              <input type="email" id="email"
                                                 value={this.state.email}
                                                 onChange={this.handleChange}
                                                 className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="row">
                                      <div className="col-lg-12">
                                          <div className="form-group has-feedback">
                                              <label>Password</label>
                                              <input type="password"
                                                    id="password"
                                                    value={this.state.password}
                                                    onChange={this.handleChange}
                                               className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="row">
                                      <div className="col-lg-12">
                                          <div className="checkbox">
                                              <input type="checkbox" id="chkRemember" />
                                              <label for="chkRemember">Remember me</label>
                                          </div>
                                      </div>
                                  </div>

                                  <LoaderButton block bsSize="large"
                                               disabled = {!this.validateForm()}
                                               type="submit"
                                               isLoading={this.state.isLoading}
                                               text="Login"
                                               loadingText="Logging in..."
                                               className="btn btn-styled btn-lg btn-block btn-info mt-4"/>
                                    <br />
                                    <div className="text-center">
                                        Forgot Password?<a href="/forgotpassword" > Please click here </a>
                                    </div>
                              </form>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </section>

      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Login.js